import { render, staticRenderFns } from "./VideoShare.vue?vue&type=template&id=5bdb5a1f&"
import script from "./VideoShare.vue?vue&type=script&lang=js&"
export * from "./VideoShare.vue?vue&type=script&lang=js&"
import style0 from "./VideoShare.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./VideoShare.vue?vue&type=style&index=1&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCard,VImg})
